import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const SubaccountsListTable = ({
  children,
  count,
  company,
  subcompany,
  permissions,
  handleToggle = () => {},
  handleOrderChange = () => {},
  order = '',
  orderBy = '',
  t,
}) => {
  const headers = [
    { variable: 'key', text: t('subaccounts.fields.key') + ': ', type: 'h3' },
    { variable: 'name', text: t('subaccounts.fields.name') + ': ' },
    {
      variable: 'description',
      text: t('subaccounts.fields.description') + ': ',
    },
    {
      parent: 'parent',
      variable: 'name',
      text: t('subaccounts.fields.parent') + ': ',
    },
    {
      variable: 'active',
      text: t('subaccounts.fields.active') + ': ',
      boolean: true,
    },
  ];

  const config = {
    actions: t('common.actions'), //Texto de seccion de acciones
    edit: t('common.edit'), //Texto de boton editar
    editPermission: 'acl.accounts.update',
    togglePermission: 'acl.accounts.toggle',
    editUrl: 'subaccounts', //Url para editar empleado
    propsName: 'subaccount', //de donde se obtienen los props
    company: company,
    subcompany: subcompany,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    permissions: permissions,
    handleClick: handleToggle,
  };

  return (
    <Common.List dataCard={dataCard}>
      <thead>
        <tr>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="key"
            handleOrderChange={handleOrderChange}
          >
            {t('subaccounts.fields.key')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="name"
            handleOrderChange={handleOrderChange}
          >
            {t('subaccounts.fields.name')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="description"
            handleOrderChange={handleOrderChange}
          >
            {t('subaccounts.fields.description')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="description"
            handleOrderChange={handleOrderChange}
          >
            {t('subaccounts.fields.parent')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="active"
            handleOrderChange={handleOrderChange}
            className="text-center"
          >
            {t('subaccounts.fields.active')}
          </Common.ThSortable>

          <th className="text-center">{t('common.actions')}</th>
        </tr>
      </thead>
      <tbody>
        {count === 0 && <Common.EmptyTable colSpan={10} />}
        {children}
      </tbody>
    </Common.List>
  );
};

export default translate()(SubaccountsListTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/components/list/SubaccountsListTable.js